import React from 'react'
import { Card, CardContent, Grid2, Icon, Typography } from '@mui/material'
import CloudOffIcon from '@mui/icons-material/CloudOff'
import i18n from 'simple-react-i18n'

const NoDataPanel = () => (
    <Grid2 container size={12} justifyContent='center' alignItems='center' spacing={1} sx={{ padding: '5 10 5 0' }}>
        <CloudOffIcon />
        <Typography variant='h6' fontWeight='bold'>{i18n.noDataToDisplay}</Typography>
    </Grid2>
)

const NoDataCard = () => (
    <Card>
        <CardContent>
            <NoDataPanel />
        </CardContent>
    </Card>
)

const NoDataPanelColumn = () => (
    <Grid2 container size={12} sx={{ fontSize: 14, color: 'black' }} justifyContent='center' alignItems='center' direction='column' spacing={0}>
        <Grid2 size='auto'>
            <Icon style={{ fontSize: 50 }}>cloud_off</Icon>
        </Grid2>
        <Grid2 size='auto'>
            {i18n.noResults}
        </Grid2>
    </Grid2>
)

export { NoDataCard, NoDataPanel, NoDataPanelColumn }